import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconOrder = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', ...other } = props;

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 8.00098H16V6.21098H4V8.00098ZM19 22.001L17.5 20.421L16 22.001L14.5 20.421L13 22.001L11.5 20.421L10 22.001L8.5 20.421L7 22.001L5.5 20.421L4 22.001L2.5 20.421L1 22.001V4.11098C1 3.53098 1.2 3.04098 1.59 2.62098C1.98 2.21098 2.45 2.00098 3 2.00098H17C17.55 2.00098 18.02 2.21098 18.41 2.62098C18.8 3.03098 19 3.53098 19 4.11098V22.001ZM16 14.001H4V16.001H16V14.001ZM16 10.001H4V12.001H16V10.001Z"
          fill={color}
        />
        <path
          d="M22.41 2.62098C22.02 2.21098 21.55 2.00098 21 2.00098H19C19.55 2.00098 20.02 2.21098 20.41 2.62098C20.8 3.03098 21 3.53098 21 4.11098V20.951L21.5 20.421L23 22.001V4.11098C23 3.53098 22.8 3.04098 22.41 2.62098Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconOrder.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconOrder;
